import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { customerResource } from './../../system/customerManage/request';
import standardTable from '@/components/standardTable/index';
import { structureList, userList, deleteDepartment, accountStatus, getTemporaryToken } from './request';
import { deleteTable } from '@/api/userManage';
import departmentModel from './departmentModel';
export default {
  components: {
    standardTable,
    departmentModel
  },
  data() {
    return {
      departmentDialogVisible: false,
      nodeSelect: null,
      customerList: [],
      tableHead: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80,
        align: 'center',
        fixed: 'left'
      }, {
        slots: {
          title: '手机号'
        },
        dataIndex: 'mobile',
        align: 'center'
      }, {
        slots: {
          title: '账号'
        },
        dataIndex: 'account',
        align: 'center'
      }, {
        slots: {
          title: '管理员名称'
        },
        dataIndex: 'nickName',
        align: 'center'
      }, {
        slots: {
          title: '角色'
        },
        dataIndex: 'roles',
        align: 'center',
        scopedSlots: {
          customRender: 'roles'
        }
      }, {
        slots: {
          title: '账号架构'
        },
        dataIndex: 'structureLevel',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        scopedSlots: {
          customRender: 'status'
        },
        align: 'center'
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 350,
        fixed: 'right'
      }],
      form: {
        customerId: '',
        structureId: '',
        name: '',
        status: undefined
      },
      tableData: [],
      filterText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      loading: false
    };
  },
  watch: {
    filterText(val) {
      console.log(val);
      this.$refs.tree.filter(val);
    }
  },
  created() {
    customerResource({}).then(res => {
      this.customerList = res;
      let arr = this.customerList.filter(item => item.id == Number(sessionStorage.getItem('customerId')));
      this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('customerId')) : res[0].id;
      sessionStorage.setItem('customerId', this.form.customerId);
      this.getStructure();
      this.getaccountTable();
    });
  },
  methods: {
    // 幽灵账号登录
    jumpLogin(info) {
      const h = this.$createElement;
      let _this = this;
      this.$confirm({
        title: h => {
          return h("div", [_this.$t('此操作将会打开新的浏览器窗口，进入'), h("span", {
            "style": "color:#1890ff"
          }, [info.nickName, "/", info.account]), _this.$t('的管理后台，但不会关闭当前页面，是否继续') + '？']);
        },
        icon: 'info-circle',
        okText: _this.$t('是'),
        cancelText: _this.$t('否'),
        async onOk() {
          await _this.toJump(info.id);
          return;
        },
        onCancel() {}
      });
    },
    async toJump(userId) {
      console.log(process.env);
      const res = await getTemporaryToken({
        userId
      });
      if (res.temporaryToken) {
        sessionStorage.setItem('temporaryToken', res.temporaryToken);
        window.open(process.env.VUE_APP_HOMEURL, '_blank');
        // window.open(`http://localhost:8080/#/index`, '_blank');
        sessionStorage.removeItem('temporaryToken');
      }
    },
    customerIdFun(e) {
      sessionStorage.setItem('customerId', e);
      this.form.structureId = '';
      this.getaccountTable();
      this.getStructure();
    },
    getaccountTable() {
      let obj = this.form;
      Object.assign(obj, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      });
      userList(obj).then(res => {
        this.tableData = res.items || [];
        this.pagination.total = res.totalNum;
      });
    },
    getStructure() {
      structureList({
        customerId: this.form.customerId
      }).then(res => {
        this.data = res;
        this.$nextTick(() => {
          // 默认高亮选中节点
          this.$refs.tree.setCurrentKey(this.data[0].id);
        });
      });
    },
    handleAdd() {},
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleStandardTableChange(val) {
      console.log(val);
      this.pagination = val;
      this.getaccountTable();
    },
    handleNodeClick(data) {
      this.form.structureId = data.id;
      this.getaccountTable();
    },
    editDepartment(node, data) {
      this.departmentDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.departmentModel.init(this.form.customerId, data);
      });
    },
    addDepartment(node, data) {
      this.departmentDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.departmentModel.init(this.form.customerId, data, true);
      });
    },
    delDepartment(node, data) {
      let _this = this;
      userList({
        page: 1,
        pageSize: 10,
        customerId: this.form.customerId,
        structureId: data.id
      }).then(res => {
        console.log(res.items);
        if (res.items.length == 0) {
          this.$alert(_this.$t('是否确认删除该部门'), {
            confirmButtonText: _this.$t('确定')
          }).then(() => {
            deleteDepartment({
              structureId: data.id
            }).then(res => {
              _this.$message.success(_this.$t('删除成功') + '!');
              _this.getaccountTable();
              _this.getStructure();
            });
          });
        } else {
          this.$message.error(this.$t('该部门下还有账号存在，暂时无法删除！'));
        }
      });
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(_this.$t('是否确认删除该账号') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        deleteTable({
          customerId: this.form.customerId,
          userId: val.id
        }).then(res => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getaccountTable();
        });
      });
    },
    checkedFun(val) {
      if (!this.isAuth('home.customerUserStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      accountStatus({
        customerId: this.form.customerId,
        userId: val.id,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功') + '!');
        val.status = val.status == 1 ? 0 : 1;
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};